const _ = require('lodash');
import I18n from '@utils/i18n';

export const DEFAULT_PAGE_SIZE = 25;
export const pageSizes = (pageSize) => {
  return [pageSize, pageSize * 2, pageSize * 4, pageSize * 10];
};

const adjustColumnMenuPosition = ($container) => {
  const $animationContainer = $container.closest('.k-animation-container');
  if (!$animationContainer.length) return;

  const viewportPadding = 8;
  // Measure the popup content ($container) rather than the animation container.
  // The animation container has a fixed/stale height (e.g. 28px) that does not
  // grow when Vue renders additional content inside it asynchronously, so using
  // its getBoundingClientRect() would miss the real overflow.
  const rect = $container[0].getBoundingClientRect();
  const overflowBottom = rect.bottom - window.innerHeight + viewportPadding;
  const overflowTop = viewportPadding - rect.top;

  if (overflowBottom > 0 || overflowTop > 0) {
    const currentTop = parseFloat($animationContainer.css('top') || '0') || 0;
    const adjustedTop = Math.max(viewportPadding, currentTop - Math.max(overflowBottom, 0) + Math.max(overflowTop, 0));
    $animationContainer.css('top', `${adjustedTop}px`);
  }
};

export const buildGridSettings = (tableElement, additionalSettings = {}) => {
  const settings = {
    dataSource: {
      transport: {
        // "jsonp" is required for cross-domain requests; use "json" for same-domain requests
        read: {
          url: tableElement.getAttribute('data-src-url'),
          dataType: 'json'
        }
      },
      schema: {
        parse: (response) => response,
        data: 'data',
        total: 'total_count',
        model: {}
      },
      serverPaging: true,
      serverFiltering: true,
      serverSorting: true
    },
    filterable: false,
    sortable: true,
    pageable: {
      pageSize: DEFAULT_PAGE_SIZE,
      pageSizes: pageSizes(DEFAULT_PAGE_SIZE),
      messages: translatedMessages('pageable')
    },
    autoBind: false, // to have a better control over when to make a real Back-End API call
    columnMenu: {
      componentType: 'modern',
      filterable: false,
      messages: translatedMessages('columnMenu')
    },
    columnMenuInit(e) {
      const $container = e.container;

      $container.css({
        'max-height': 'calc(100vh - 8rem)',
        'overflow-y': 'auto',
        'overflow-x': 'hidden'
      });

      adjustColumnMenuPosition($container);
      window.requestAnimationFrame(() => {
        // The column menu content is rendered by Vue asynchronously after columnMenuInit
        // fires, so we must expand the columns section and recalculate position here.
        // The header uses [data-expander-header] and the content wrapper uses display:none
        // (jQuery), so we show it directly to avoid animation timing issues.
        const $header = $container.find('[data-expander-header][aria-expanded="false"]');
        if ($header.length) {
          $header.attr('aria-expanded', 'true');
          $header.siblings('.k-expander-content-wrapper').show();
        }
        // Kendo animates the popup open via a scaleY CSS transition (~100ms ease-out).
        // While the transform is active, getBoundingClientRect() returns near-zero
        // dimensions and position adjustments would be incorrect. We must wait for
        // the transition to complete before reading the real dimensions.
        let adjusted = false;
        const doAdjust = () => {
          if (adjusted) return;
          adjusted = true;
          $container[0].removeEventListener('transitionend', doAdjust);
          adjustColumnMenuPosition($container);
        };
        $container[0].addEventListener('transitionend', doAdjust);
        // Fallback: if transitionend never fires, adjust after 200ms
        setTimeout(doAdjust, 200);
      });
    }
  };

  return _.merge(settings, additionalSettings);
};

const translatedMessages = (scope) => {
  if (I18n.locale !== 'es') return {};

  return {
    columnMenu: {
      sortAscending: 'Orden ascendente',
      sortDescending: 'Orden descendente',
      columns: 'Columnas',
      reset: 'Reiniciar',
      apply: 'Solicitar'
    },
    pageable: {
      display: '{0} - {1} de {2} ítems',
      empty: 'No hay elementos para mostrar',
      page: 'Página',
      allPages: 'Todo',
      of: 'de {0}',
      itemsPerPage: 'ítems por página',
      first: 'Ir a la primera página',
      previous: 'Ir a la página anterior',
      next: 'Ir a la página siguiente',
      last: 'Ir a la última página'
    }
  }[scope];
};
